import styled from 'styled-components'

export const Row = styled.div`
  margin-bottom: ${({ theme }) => theme.space.mobile.tiny};

  &:last-child {
    margin-bottom: 0;
  }
`
